import { Getters, Mutations, Actions, Module } from "vuex-smart-module";
import AuthService from "@/services/AuthService";
import store from "..";
import Axios from "axios";

const NO_EMULATORS = true;
let axios = Axios.create();
if (process.env.NODE_ENV === "development" && NO_EMULATORS) {
  axios = Axios.create({
    baseURL: "https://beta.yac.com",
  });
}

const authService = new AuthService();

export class AuthState {}

class AuthGetters extends Getters<AuthState> {}

class AuthMutations extends Mutations<AuthState> {}

class AuthActions extends Actions<
  AuthState,
  AuthGetters,
  AuthMutations,
  AuthActions
> {
  async linkWithGoogle() {
    if (!authService.currentUser) {
      throw new Error("We couldn't find your profile.");
    }
    await authService.currentUser.linkWithPopup(
      new authService.providers.Google()
    );
  }
  async linkWithEmailAndPassword(payload: { email: string; password: string }) {
    if (!authService.currentUser) {
      throw new Error("We couldn't find your profile.");
    }
    await authService.currentUser.linkWithCredential(
      authService.providers.EmailAndPassword.credential(
        payload.email,
        payload.password
      )
    );
  }

  async loggedIn(){
    if(authService.currentUser){
      const token = await authService.currentUser.getIdToken(true);
      const url = "/auth/login";
      
      try{
        await axios.post(url, { token }, {withCredentials: true});
      }catch(e){
        //@ts-ignore
      }
    }else{
      const url = "/auth/logout";
      
      try{
        await axios.get(url, {withCredentials: true});
      }catch(e){
        //@ts-ignore
      }
    }
  }

  async signInAnonymously() {
    store.commit("user/SET_LOADING", true);
    const url = "/auth/status";
      
    try{
      const resp = await axios.get(url, {withCredentials: true});
      if(resp.data.token){
        await authService.signInWithToken(resp.data.token);
      }else{
        await authService.signInAnonymously();
      }
    }catch(e){
      await authService.signInAnonymously();
    }
  }

  async logout() {
    await authService.logout();
    store.dispatch("user/clear");
  }
}

// Create a module with module asset classes
const AuthModule = new Module({
  namespaced: true,
  state: AuthState,
  getters: AuthGetters,
  mutations: AuthMutations,
  actions: AuthActions,
});

export default AuthModule;
